
angular.module('atex.aceui.application', ['atex.aceui.service']);
